/* eslint-disable @typescript-eslint/no-empty-function */
import { useState } from 'react';
import { VictoryPie } from 'victory';
import download from '../../../../../../assets/images/icons/download.svg';
import info from '../../../../../../assets/images/icons/info.svg';
import NoData from '../../../../../../components/NoData';
import OpacityAnimation from '../../../../../../components/OpacityAnimation';
import useThemeContext from '../../../../../../contexts/theme';
import ExportXlsx from '../../../../../../utils/ExportXlsx';
import { PeriodType, TotConsultasLocTrab } from '../../../types';
import { Card } from './styles';

interface IWorkplacesCard {
  consultsByWorkplaces: TotConsultasLocTrab[];
  period: PeriodType;
}

export default function WorkplacesCard({ consultsByWorkplaces, period }: IWorkplacesCard) {
  const { selectedTheme } = useThemeContext();
  const [labelBeingShow, setLabelBeingShow] = useState({ description: '', value: '' });

  const descendingOrder = consultsByWorkplaces?.sort((a, b) => (
    b.totalConsultas - a.totalConsultas
  ));

  const tenBiggest = descendingOrder?.slice(0, 10);

  function downloadRel() {
    ExportXlsx({
      filename: `Quantidade de Consultas por Local de Trabalho - ${period.month}_${period.year}`,
      data: consultsByWorkplaces.map((x) => ({
        'Código Local de Trabalho': x.codEndA,
        'Local de Trabalho': x.localTrab,
        'Quantidade de Consultas': x.totalConsultas
      }))
    });
  }

  return (
    <Card>
      <div className="card-title">
        <div>
          Consultas por Local de Trabalho (10+)
          <img src={info} alt="" className='primaryColor info' title='Quantidade de roteirizações realizadas em cada local de trabalho, constando apenas os 10 locais com maior quantidade de roteirizações feitas.'/>
        </div>
        <img src={download} alt="download" title="Baixar relatório excel" onClick={() => downloadRel()} />
      </div>

      {(!!consultsByWorkplaces && consultsByWorkplaces.length > 0) && (
        <>
          <OpacityAnimation>
            <div className="card-main-graph">
              <VictoryPie
                data={tenBiggest.map((cst) => ({
                  x: `${cst.localTrab}\n(${cst.codEndA})`, y: cst.totalConsultas
                }))}
                animate={{
                  duration: 500
                }}
                colorScale="qualitative"
                height={335}
                labelPlacement="vertical"
                labelRadius={0.1}
                labelPosition="endAngle"
                style={{
                  labels: { fontSize: 0, fill: selectedTheme === 'dark' ? '#fff' : '#000' }
                }}
                padding={{ top: 0, bottom: 10 }}
                innerRadius={110}
                padAngle={1}
                events={[{
                  target: 'data',
                  eventHandlers: {
                    onMouseOver: () => {
                      return [
                        {
                          target: 'data',
                          mutation: ({ style, data, index }) => {
                            setLabelBeingShow({ description: data[index].x, value: data[index].y });
                            return { style: Object.assign({}, style, { opacity: '0.8', cursor: 'help' }) };
                          }
                        }
                      ];
                    },
                    onMouseOut: () => {
                      return [
                        {
                          target: 'data',
                          mutation: () => {
                            setLabelBeingShow({ description: '', value: '' });
                            return null;
                          }
                        }
                      ];
                    }
                  }
                }]}
              />
              <label>
                <span>{labelBeingShow.value ? Number(labelBeingShow.value).toFixed(0) : ''}</span>
                <span>{labelBeingShow.description}</span>
              </label>
            </div>
          </OpacityAnimation>
        </>
      )}

      {(!consultsByWorkplaces || consultsByWorkplaces.length === 0) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não há dados disponíveis sobre consultas por local de trabalho
            </>
          )}
        />
      )}
    </Card>
  );
}
